<script setup lang="ts">
  import { isString } from '@borg/utils';

  const router = useRouter();

  function onBack() {
    const backRoute = router.options.history.state.back;
    if (backRoute) {
      if (isString(backRoute) && /source/.test(backRoute)) {
        // prevents having to click the back button twice,
        // because the only thing changing is the 'source' param in the url
        router.go(-2);
      } else {
        router.back();
      }
    } else {
      navigateTo('/');
    }
  }
</script>

<template>
  <WithBackButton @click="onBack">
    <section class="notifications no-print">
      <NotificationJobInactive />
      <NotificationJobApplied />
    </section>
    <LayoutGrid>
      <JobInfoCard />
      <JobHTMLCard />
      <template #aside>
        <OrganizationCard show-link />
        <JobAdditionalInfoCard />
        <MyPaycheck />
        <PPI />
        <EduCentar />
      </template>
    </LayoutGrid>
    <JobDetailsActionBar />
  </WithBackButton>
</template>

<style scoped lang="scss">
  .notifications {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-50);
    max-width: calc(736px + 352px + var(--mp-space-70));
  }
</style>
